import React from "react";
// import LawyerImage from "./images/scout.png";
import FieldTrips from "./images/FieldTrip.png";
import About from "./About";
// import "./fieldTrip.css";
import "./fieldTripNew.css";

const Fieldtrip = () => {
  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <img src={FieldTrips} class="" />
          </div>
        </div>
      </div>
      <About />
    </div>
  );
};

export default Fieldtrip;
